import useRobotPhotos from '../../store/robotPhotoes'
import { Box, Stack, Tab, Tabs, Typography } from '@mui/material'
import robotImage from 'images/robot3.png'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ROBOT_MODES, robotModes } from 'utils/constants'

interface Props {
  activeMode?: ROBOT_MODES
}

const RobotImageBlock = ({ activeMode }: Props) => {
  const { t } = useTranslation()
  const [tabValue, setTabValue] = useState<'front' | 'rear'>('front')
  const [imageSrc, setImageSrc] = useState<string>(robotImage)

  const frontPhoto = useRobotPhotos(s => s.frontPhoto)
  const rearPhoto = useRobotPhotos(s => s.rearPhoto)

  const handleTabChange = (_: React.SyntheticEvent, newValue: 'front' | 'rear') => {
    setTabValue(newValue)
  }

  useEffect(() => {
    if (tabValue == 'rear') {
      setImageSrc(rearPhoto)
    } else {
      setImageSrc(frontPhoto)
    }
  }, [frontPhoto, rearPhoto, tabValue])

  return (
    <Stack direction="column" borderRadius={2} paddingX={2} height="100%" bgcolor="info.main">
      <Box width="100%" height="70%">
        <Tabs value={tabValue} onChange={handleTabChange} centered sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tab label={t('robotView.front')} value="front" />
          <Tab label={t('robotView.rear')} value="rear" />
        </Tabs>
        <img
          src={imageSrc || robotImage}
          alt={tabValue === 'front' ? 'robot front' : 'robot rear'}
          width="100%"
          height="100%"
          style={{ objectFit: 'contain' }}
        />
      </Box>
    </Stack>
  )
}

export default RobotImageBlock
